import React from "react";
import CreatePoTabs from "./CreatePoTabs";

const CreatePO = ({
  initialValues = {},
  onSubmit,
  onCancel = () => {},
  mode = 'create',
  readOnly = false
}) => {
  const handleSubmit = (formData) => {
    console.log("Form submitted with data:", formData);
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  return (
    <CreatePoTabs 
      initialValues={initialValues} 
      onCancel={onCancel} 
      onSubmit={handleSubmit} 
      mode={mode}
      readOnly={readOnly}
    />
  );
};

export default CreatePO;